import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { setDlmStatusAndVersion } from 'reducers/dlmReducer';
import businessRelationService from 'services/businessRelationService';
import { BrVersionDto } from 'views/RevisionHistory/Br/BrRevisionDtos';
import { isNotNullOrUndefined } from 'utils/utils';

export const useFetchBrVersions = (techId: string) => {
  const dispatch = useDispatch();

  const query = useQuery<BrVersionDto[], AxiosError>({
    queryKey: ['fetchBrVersions', techId],
    queryFn: () => businessRelationService.getBrVersions(techId),
    gcTime: 0,
  });

  const { error, isError } = query;

  useEffect(() => {
    if (isError && isNotNullOrUndefined(error)) {
      dispatch(setDlmStatusAndVersion({ status: 'ACTIVE', version: 1 }));
    }
  }, [isError, error, dispatch]);

  return query;
};
